<template>
  <Row>
    <Column :width="15">
      <div id="detailsModal" class="rc-modal-dialog">
        <!-- Modal content -->
        <div class="rc-modal-content-dialog-small-medium">
          <div class="rc-modal-header-dialog">
            <Box :key="redraw">
              <Row v-for="(row, rowIndex) in viewHeaderData" :key="rowIndex">
                <CellFactory :rowData="row.data" :showMissingRequirements="showMissingRequirements"
                  v-on:withValue="withFieldValue" v-on:withButtonPressed="withButtonPressed" />
              </Row>
            </Box>
          </div>

          <div class="rc-modal-body-dialog">
            <div class="rc-modal-body-inner-dialog rc-border-thin">
              <Box :key="redraw + 1">
                <Row v-for="(row, rowIndex) in viewBodyData" :key="rowIndex">
                  <CellFactory :rowData="row.data" :showMissingRequirements="showMissingRequirements"
                    v-on:withValue="withFieldValue" v-on:withButtonPressed="withButtonPressed" />
                </Row>
              </Box>
            </div>
          </div>

          <div class="rc-modal-footer-dialog">
            <Box :key="redraw + 2">
              <Row v-for="(row, rowIndex) in viewFooterData" :key="rowIndex">
                <CellFactory :rowData="row.data" :showMissingRequirements="showMissingRequirements"
                  v-on:withValue="withFieldValue" v-on:withButtonPressed="withButtonPressed" />
              </Row>
            </Box>
          </div>
        </div>
      </div>
    </Column>
  </Row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ConnectionUtils from '@/utils/ConnectionUtils.js';
import ConstUtils from '@/utils/ConstUtils.js';
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';

import MC from "@/domain/session/MC.js";

import Column from "@/portals/shared/library/box/Column.vue";
import Row from "@/portals/shared/library/box/Row.vue";
import Box from "@/portals/shared/library/box/Box.vue";
import CellFactory from "@/portals/shared/cell/CellFactory.vue";

import BoxDisplayRow from "@/portals/shared/cell/box/BoxDisplayRow";
import RowDisplayRow from "@/portals/shared/cell/row/RowDisplayRow";

import TitleDisplayRow from "@/portals/shared/cell/title/TitleDisplayRow";
import ButtonDisplayRow from "@/portals/shared/cell/button/ButtonDisplayRow";
import ErrorDisplayRow from "@/portals/shared/cell/error/ErrorDisplayRow";
import SpacerDisplayRow from "@/portals/shared/cell/spacer/SpacerDisplayRow";
import StringDisplayRow from "@/portals/shared/cell/string/StringDisplayRow";
import CheckboxUpdateRow from "@/portals/shared/cell/checkbox/CheckboxUpdateRow";

import Company from "@/domain/model/company/Company.js";

export default {
  name: "company-update-view",
  components: {
    Column,
    Row,
    Box,
    CellFactory,
  },
  props: {
    itemId: { type: String, default: "" },
  },
  data() {
    return {
      redraw: 1,
      MC: new MC(),
      Strings: StringUtils,
      Contents: ContentUtils,
      Consts: ConstUtils,

      company: null,
      features: null,

      showMissingRequirements: false,
      viewBodyData: [],
      viewFooterData: [],
      viewHeaderData: [],

      kvps: {},
      error: null,
      showDialog: null,
    };
  },
  computed: {
    ...mapGetters([
      'auth_connected',
      'auth_socket_status',
      'signin_event',
      'auth_client',
      'domain',
    ]),
  },
  mounted: function () {
    ConnectionUtils.ensureConnection(this);
  },
  watch: {
    auth_connected() {
      ConnectionUtils.sendSignInEvent(this);
    },
    auth_socket_status() {
      ConnectionUtils.displayStatus(this);
    },
    signin_event() {
      ConnectionUtils.createDomainSession(this);
    },
  },
  methods: {
    ...mapActions([
      'AuthStorage_updateCompany',
      'addListenerAction',
      'removeListenerAction',
      'updateDomain',
    ]),

    start: function () {
      this.company = new Company(this.domain);
      if (StringUtils.isNotEmpty(this.itemId)) {
        var id = ContentUtils.baseDecode(this.itemId);
        this.company = this.domain.companys().findById(id).copy();
        this.features = this.company.features().find();
      }
      this.setup();
      this.mainScreen();
    },

    setup: function () {
      // window.onclick = this.onClick;
    },

    mainScreen: function () {
      this.viewHeaderData = [];
      this.viewBodyData = [];
      this.viewFooterData = [];
      this.paint();
      let features = this.company.features().find();
      var errorBox = new BoxDisplayRow().withBorder(true)
        .withChild(new RowDisplayRow()
          .withChild(new SpacerDisplayRow().withWidth("1"))
          .withChild(new ErrorDisplayRow().withWidth("13").withError(this.error))
          .withChild(new SpacerDisplayRow().withWidth("1"))
        );
      if (this.error) {
        this.viewBodyData.push(errorBox);
      }

      let titleRow = new RowDisplayRow().withWidth(15);
      let title = new TitleDisplayRow().withTitle("User Profile Permissions").withWidth(15);
      titleRow.withChild(title);
      this.viewHeaderData.push(new BoxDisplayRow().withWidth(15).withChild(titleRow));

      let cancelButton = new ButtonDisplayRow().withWidth(3).withName("Cancel").withField("CloseDialog");
      let saveButton = new ButtonDisplayRow().withWidth(3).withName("Save").withField("Save").withBackgroundPrimaryAction();
      let footerRow = new RowDisplayRow().withWidth(15);
      footerRow.withChild(cancelButton);
      footerRow.withChild(new SpacerDisplayRow().withWidth(9));
      footerRow.withChild(saveButton);
      this.viewFooterData.push(new BoxDisplayRow().withWidth(15).withChild(footerRow));


      let permissionsBox = new BoxDisplayRow().withWidth(15);
      let permissionsRow = new RowDisplayRow().withWidth(15);
      let profileUpdateAllowedCheckbox = new CheckboxUpdateRow().withShowCheckbox(false).withName("Allow Profile Updates").withDefaultValue(this.company.userCanUpdateProfile()).withHint("Allows all users to update their name, email, phone, address and driver's license information").withField('ProfileUpdate').withWidth(11);
      permissionsRow.withChild(new SpacerDisplayRow().withWidth(2));
      permissionsRow.withChild(profileUpdateAllowedCheckbox);
      permissionsRow.withChild(new SpacerDisplayRow().withWidth(2));

      permissionsBox.withChild(permissionsRow);
      permissionsBox.withChild(new RowDisplayRow()
        .withChild(new SpacerDisplayRow().withWidth(2))
        .withChild(new CheckboxUpdateRow().withShowCheckbox(false).withName("Drivers Receive Inspection email").withDefaultValue(this.company.emailInspectionsToDriver()).withHint("After completing an inspection, drivers should receive an email to their sign in email address with inspection details, and the PDF of the inspection just completed").withField('EmailInspectionUpdate').withWidth(11))
        .withChild(new SpacerDisplayRow().withWidth(2))
      );

      if (features.allowsTimesheets()) {
        permissionsBox.withChild(new RowDisplayRow()
          .withChild(new SpacerDisplayRow().withWidth(2))
          .withChild(new CheckboxUpdateRow().withShowCheckbox(false).withName("Hours of Service Mandatory").withDefaultValue(this.company.timesheetStartedBeforeInspection()).withHint("Requires Commercial Drivers to start their Hours of Service before an inspection.  Non-Commercial Drivers are not affected by this setting as they do not require Hours of Service. ***This requires an app update to take effect.  Stay tuned").withField('TimesheetBeforeInspectionUpdate').withWidth(11))
          .withChild(new SpacerDisplayRow().withWidth(2))
        );
      }
      this.viewBodyData.push(permissionsBox);
      this.paint();
    },

    paint: function () {
      this.redraw++;
    },

    onClick: function (event) {
      var modal = document.getElementById("detailsModal");
      if (event.target == modal) {
        this.goBack();
      }
    },

    log() {
      return this.domain.logger();
    },

    resetMissingValues() {
      if (this.showMissingRequirements) {
        this.showMissingRequirements = false;
      }
    },

    callback: function (msg) {
      if (msg) {
        //
      }
    },

    areRequirementsMet() {
      var met = true;
      return met;
    },

    goBack: function () {
      this.$router.back();
    },

    withFieldValue: function (valueData) {
      if (valueData["field"] === "ProfileUpdate") {
       this.company.toggleUserCanUpdateProfile();
      }
      if (valueData["field"] === "EmailInspectionUpdate") {
        this.company.toggleEmailInspectionsToDriver();
      }

      if (valueData["field"] === "TimesheetBeforeInspectionUpdate") {
        this.company.toggleTimesheetStartedBeforeInspection();
      }
      this.log().info("{0}", [JSON.stringify(this.company.data)]);
      this.$emit("withValue", valueData);
    },

    withButtonPressed: function (buttonData) {
      if (buttonData["field"] === "CloseDialog") {
        this.$emit("withButtonPressed", buttonData);

      } else if (buttonData["field"] === "Save") {
        if (this.areRequirementsMet()) {
          this.sendingScreen();
          let operation = this.domain.events().companySave(this.company.data);
          let context = { view: this }
          operation.send(this.listener, context);
        } else {
          this.showMissingRequirements = true;
        }
      }
      this.$emit("withButtonPressed", buttonData);
    },

    urlQueryParams() {
      return Object.assign({}, this.$route.query);
    },

    listener(notification, context) {
      this.doneScreen();
      if (!notification || !context) {
        return;
      }
      if (notification.error()) {
        this.error = notification.error();
        this.mainScreen();
        return;
      }

      var buttonData = {};
      buttonData["field"] = "CloseDialog";
      buttonData["refresh"] = true;
      this.$emit("withButtonPressed", buttonData);
    },

    sendingScreen() {
      this.viewBodyData = [];
      this.viewFooterData = [];
      this.viewHeaderData = [];

      let bodyBox = new BoxDisplayRow().withChild(new RowDisplayRow()
        .withChild(new SpacerDisplayRow().withWidth("2"))
        .withChild(new BoxDisplayRow()
          .withWidth("11")
          .withChild(new StringDisplayRow()
            .withValue("Sending"))
        )
        .withChild(new SpacerDisplayRow().withWidth("2"))
      );
      this.viewBodyData.push(bodyBox);
      this.paint();
    },

    doneScreen() {
      this.viewHeaderData = [];
      this.viewBodyData = [];
      this.viewFooterData = [];

      let bodyBox = new BoxDisplayRow().withChild(new RowDisplayRow()
        .withChild(new SpacerDisplayRow().withWidth("2"))
        .withChild(new BoxDisplayRow()
          .withWidth("11")
          .withChild(new StringDisplayRow()
            .withMandatoryValue(true)
            .withValue("Done!"))
        )
        .withChild(new SpacerDisplayRow().withWidth("2"))
      );

      this.viewBodyData.push(bodyBox);
      this.paint();
    },
  }
};

</script>